import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Button } from 'components/misc'
import { form } from 'helpers/decorators'

@form({
  form: 'taskEmailRevisionClear'
})
class TaskEmailRevisionClear extends Component {
  static propTypes = {
    id: PropTypes.number.isRequired,
    title: PropTypes.string,
    intlKey: PropTypes.string,
    handleSubmit: PropTypes.func,
    modal: PropTypes.func.isRequired,
    proceed: PropTypes.func.isRequired,
    submitting: PropTypes.bool
  }

  static defaultProps = {
    title: 'Clear email revision',
    intlKey: 'tasks.clear_email_revision'
  }

  handleDismiss = () => this.props.modal(null)

  handleProceed = fields => {
    const { id, proceed } = this.props

    return proceed(id, fields)
      .then(() => this.props.modal(null))
  }

  render() {
    const {
      handleSubmit,
      title,
      intlKey,
      submitting
    } = this.props

    return (
      <form onSubmit={handleSubmit(this.handleProceed)}>
        <h2 className="text--center">
          <FormattedMessage id={intlKey} defaultMessage={title} />?
        </h2>
        <div className="row">
          <div className="col-xs-6">
            <Button type="button" secondary onClick={this.handleDismiss}>
              <FormattedMessage id="button.dismiss" defaultMessage="Dismiss" />
            </Button>
          </div>
          <div className="col-xs-6 text--right">
            <Button isLoading={submitting}>
              <FormattedMessage id="button.clear" defaultMessage="Clear" />
            </Button>
          </div>
        </div>
      </form>
    )
  }
}

export default TaskEmailRevisionClear
